import React from 'react';

const DefaultButton = ({description, icon, onClick, small = false}) => {
    return (
        <button className={`btn ${small ? 'btn-sm' : 'btn-pill'} btn-outline-secondary flex btn-icon alg-center`} type="button" onClick={onClick}>
            {icon}
            {description}
        </button>
    )
}

export default DefaultButton;